export default {"src":"/_next/static/media/HeaderArbitrumLogoMainnet.93628cc4.svg","height":489,"width":1920,"blurWidth":0,"blurHeight":0};